(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-2024-email"] && !Shopify.designMode) return;
  try {
    
  const switchertabs = document.querySelectorAll('.switcher-tab-btn button')
  if (!switchertabs) {
    return false
  }
  const switcherContainers1 = document.querySelectorAll('.switcher-continer-1 >div')
  const switcherContainers2 = document.querySelectorAll('.switcher-continer-2 >div')
  switchertabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      switchertabs.forEach((tab) => tab.classList.remove('uk-active'))
      switcherContainers1.forEach((container) => container.classList.add('hidden'))
      switcherContainers2.forEach((container) => container.classList.add('hidden'))
      tab.classList.add('uk-active')
      switcherContainers1[index].classList.remove('hidden')
      switcherContainers2[index].classList.remove('hidden')
    })
  })
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
  }
  const switchertabsContainer = document.querySelector('.switcher-tab-btn')
  const isSticky = switchertabsContainer.getAttribute('data-sticky')
  if (!switchertabsContainer) {
    return false
  }
  function handleStickyTabsBox() {
    if (isMobile(640) && isSticky === 'true') {
      switchertabsContainer.setAttribute('uk-sticky', 'end: !.sticky-box;offset: 78;cls-active: sticky-style')
    } else {
      switchertabsContainer.removeAttribute('uk-sticky')
    }
  }
  handleStickyTabsBox()
  window.addEventListener('resize', handleStickyTabsBox)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-2024-member-sale"] && !Shopify.designMode) return;
  try {
    
  const popverElement = document.querySelector('#popover-right')
  if (!popverElement) {
    return
  }
  const popverBtn = document.querySelector('.popover-btn')
  if (!popverBtn) {
    return
  }
  const popver = new Popover(popverElement)
  // Show drawer on hover
  popverBtn.addEventListener('click', () => {
    popver.hide()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-2024-nav"] && !Shopify.designMode) return;
  try {
    
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
  }
  document.addEventListener('DOMContentLoaded', function () {
    const tabsBox = document.querySelector('.sticky-tabs-box')
    if (!tabsBox) return
    var tabs = tabsBox.querySelectorAll('.PageNav')
    var stickyToTop = isMobile(1024) ? 62 : 64
    var sections = Array.from(tabs).map(function (tab) {
      var href = tab.getAttribute('href')
      if (href && href !== '#') {
        return document.querySelector(href)
      }
    })
    //处理点击事件
    tabs.forEach((tab,index) => {
      tab.addEventListener('click', function (event) {
        event.preventDefault()
        if (sections[index]) {
          window.scrollTo({
            top: sections[index].offsetTop - stickyToTop, // 偏移粘头高度
            behavior: 'smooth'
          })
        }
      })
    })
    // 处理滚动事件
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY
      sections.forEach(function (section, index) {
        if (!section) return
        var sectionTop = section.offsetTop - stickyToTop - 30 // 偏移粘头高度
        var sectionHeight = section.offsetHeight
        var tab = tabs[index]
        // 导航跟随滚动start
        const tabWidth = tab.offsetWidth
        const tabLeft = tab.offsetLeft
        const tabRight = tabLeft + tabWidth + 50
        const tabContainerWidth = tabsBox.offsetWidth
        const tabContainerScrollLeft = tabsBox.scrollLeft
        const tabContainerScrollRight = tabContainerScrollLeft + tabContainerWidth
        // 导航跟随滚动end
        if (section.style.display !== 'none') {
          if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
            tab.classList.add('tm-active')
            // 导航跟随滚动start
            if (tabLeft < tabContainerScrollLeft) {
              tabsBox.scrollTo({
                left: tabLeft - 100,
                behavior: 'smooth'
              })
            } else if (tabRight > tabContainerScrollRight) {
              tabsBox.scrollTo({
                left: tabRight - tabContainerWidth,
                behavior: 'smooth'
              })
            }
            // 导航跟随滚动end
          } else {
            tab.classList.remove('tm-active')
          }
        } else {
          tab.classList.remove('tm-active')
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-2025-nav"] && !Shopify.designMode) return;
  try {
    
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
  }
  document.addEventListener('DOMContentLoaded', function () {
    const tabsBox = document.querySelector('.sticky-tabs-box')
    if (!tabsBox) return
    var tabs = tabsBox.querySelectorAll('.PageNav')
    var stickyToTop = isMobile(1024) ? 48 : 68
    var sections = Array.from(tabs).map(function (tab) {
      var href = tab.getAttribute('href')
      if (href && href !== '#') {
        return document.querySelector(href)
      }
    })
    //处理点击事件
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function (event) {
        // event.preventDefault()
        // if (sections[index]) {
        //   window.scrollTo({
        //     top: sections[index].offsetTop - stickyToTop, // 偏移粘头高度
        //     behavior: 'smooth'
        //   })
        // }
      })
    })
    // 处理滚动事件
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY
      sections.forEach(function (section, index) {
        if (!section) return
        var sectionTop = section.offsetTop - stickyToTop - 30 // 偏移粘头高度
        var sectionHeight = section.offsetHeight
        var tab = tabs[index]
        // 导航跟随滚动start
        const tabWidth = tab.offsetWidth
        const tabLeft = tab.offsetLeft
        const tabRight = tabLeft + tabWidth + 50
        const tabContainerWidth = tabsBox.offsetWidth
        const tabContainerScrollLeft = tabsBox.scrollLeft
        const tabContainerScrollRight = tabContainerScrollLeft + tabContainerWidth
        // 导航跟随滚动end
        if (section.style.display !== 'none') {
          if (scrollY >= sectionTop && scrollY < (sectionTop + sectionHeight)) {
            tab.classList.add('tm-active')
            // 导航跟随滚动start
            if (tabLeft < tabContainerScrollLeft) {
              tabsBox.scrollTo({
                left: tabLeft - 100,
                behavior: 'smooth'
              })
            } else if (tabRight > tabContainerScrollRight) {
              tabsBox.scrollTo({
                left: tabRight - tabContainerWidth,
                behavior: 'smooth'
              })
            }
            // 导航跟随滚动end
          } else {
            tab.classList.remove('tm-active')
          }
        } else {
          tab.classList.remove('tm-active')
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charger-nav"] && !Shopify.designMode) return;
  try {
    
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
  }
  document.addEventListener('DOMContentLoaded', function () {
    const tabsBox = document.querySelector('.sticky-tabs-box')
    if (!tabsBox) return
    var tabs = tabsBox.querySelectorAll('.PageNav')
    var stickyToTop = isMobile(640) ? 48 : 68
    var sections = Array.from(tabs).map(function (tab) {
      var href = tab.getAttribute('href')
      if (href && href !== '#') {
        return document.querySelector(href)
      }
    })
    //处理点击事件
    tabs.forEach((tab,index) => {
      tab.addEventListener('click', function (event) {
        event.preventDefault()
        if (sections[index]) {
          window.scrollTo({
            top: sections[index].offsetTop - stickyToTop, // 偏移粘头高度
            behavior: 'smooth'
          })
        }
      })
    })
    // 处理滚动事件
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY
      sections.forEach(function (section, index) {
        if (!section) return
        var sectionTop = section.offsetTop - stickyToTop -30 // 偏移粘头高度
        var sectionHeight = section.offsetHeight
        var tab = tabs[index]
        
        // 导航跟随滚动start
        const tabWidth = tab.offsetWidth
        const tabLeft = tab.offsetLeft
        const tabRight = tabLeft + tabWidth + 50
        const tabContainerWidth = tabsBox.offsetWidth
        const tabContainerScrollLeft = tabsBox.scrollLeft
        const tabContainerScrollRight = tabContainerScrollLeft + tabContainerWidth
        // 导航跟随滚动end
        if (section.style.display !== 'none') {
          if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
            tab.classList.add('tm-active')
            // 导航跟随滚动start
            if (tabLeft < tabContainerScrollLeft) {
              tabsBox.scrollTo({
                left: tabLeft - 100,
                behavior: 'smooth'
              })
            } else if (tabRight > tabContainerScrollRight) {
              tabsBox.scrollTo({
                left: tabRight - tabContainerWidth,
                behavior: 'smooth'
              })
            }
            // 导航跟随滚动end
          } else {
            tab.classList.remove('tm-active')
          }
        } else {
          tab.classList.remove('tm-active')
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charger1-swiper"] && !Shopify.designMode) return;
  try {
    
  class videoComponent extends HTMLElement {
    constructor() {
      super()
      this.isShowMore = false
      this.showString = {
        show: 'See More',
        close: 'Close'
      }
      this.playsBtns = this.querySelectorAll('[data-code]')

      this.init()
    }

    play(code) {
      if (!code) {
        return
      }
      const videoUrl = `//www.youtube-nocookie.com/embed/${code}?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=1`
      const videoElement = `<button class="uk-modal-close-outside" type="button" uk-close></button><iframe src="${videoUrl}" width="1920" height="1080" allowfullscreen uk-responsive uk-video></iframe>`
      UIkit.modal.dialog(
        `<div>${videoElement}<style>.uk-modal{display: flex!important;}.uk-modal-dialog {width: 1200px;margin-top: auto!important;margin-bottom: auto!important;}</style></div>`
      )
    }

    init() {
      const playLength = this.playsBtns.length
      if (playLength >= 1) {
        this.playsBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.target.blur()
            this.play(e.target.dataset.code)
          })
        })
      }
    }
  }
  customElements.define('video-component', videoComponent)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-2024-member-sale"] && !Shopify.designMode) return;
  try {
    
  const popverElement = document.querySelector('#popover-right')
  if (!popverElement) {
    return
  }
  const popverBtn = document.querySelector('.popover-btn')
  if (!popverBtn) {
    return
  }
  const popver = new Popover(popverElement)
  // Show drawer on hover
  popverBtn.addEventListener('click', () => {
    popver.hide()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-cms-subscribe"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    const root = document.querySelector('.email-cms-subscribe-{{ section.id }} email-cms-subscribe')
    if (!root) return

    // Island 未就绪时阻止原生表单提交（默认 GET 会导致整页跳转）
    root.addEventListener(
      'submit',
      (event) => {
        const form = event.target
        if (!(form instanceof HTMLFormElement)) return
        if (!form.matches('[data-email-cms-form]')) return
        event.preventDefault()
      },
      true
    )

    /** 切换 Tab 时重播标题淡入（SMS 面板初始为 hidden，需在进入时触发） */
    const replaySubscribeHeading = (panel) => {
      if (!panel) return
      panel.querySelectorAll('.email-cms-subscribe__heading--animate').forEach((heading) => {
        heading.classList.remove('email-cms-subscribe__heading--animate')
        requestAnimationFrame(() => {
          heading.classList.add('email-cms-subscribe__heading--animate')
        })
      })
    }

    // Tab 切换兜底：与 email-cms-subscribe.js 逻辑一致，避免 JS 延迟加载时无法切换
    root.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-email-cms-tab]')
      if (!tab || !root.contains(tab)) return

      const tabName = tab.getAttribute('data-email-cms-tab')
      if (!tabName) return

      root.querySelectorAll('[data-email-cms-tab]').forEach((btn) => {
        const isActive = btn === tab
        btn.classList.toggle('is-active', isActive)
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false')
      })

      const emailPanel = root.querySelector('[data-email-cms-panel="email"]')
      const smsPanel = root.querySelector('[data-email-cms-panel="sms"]')
      emailPanel?.classList.toggle('hidden', tabName !== 'email')
      smsPanel?.classList.toggle('hidden', tabName !== 'sms')

      replaySubscribeHeading(tabName === 'email' ? emailPanel : smsPanel)
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["factory-2024-poinner"] && !Shopify.designMode) return;
  try {
    
  function animated() {
    let counters = document.querySelectorAll('.num');  //获取到三个counter盒子

    counters.forEach(item => {
      item.innerText = '1';  //记录分数变化的变量，初始值为0

      const updateData = () => {
        const data = +item.getAttribute('data-end');  //获取到元素中绑定的数据
        const tmp = +item.innerText; //临时变量保存变化一次的数据量
        var changeData = 0;
        changeData = data / 35;  //设置默认改变的速率
        if (tmp < data) {  //如果临时变量的值小于最终数据的值，那么就给元素进行数据相加
          item.innerText = `${Math.ceil(tmp + changeData)}`;  //值数相加，然后进行取整
          setTimeout(updateData, 5);  //定时器传入回调函数目的在于动态变化
        } else {
          item.innerText = data.toLocaleString().replace(/,/g, ' ') + '+';  //不满足条件后，证明得到了最终数据，直接渲染
        }
      }
      updateData();  //调用函数，启动函数
    })
  }

  var targetElement = document.querySelector('.factory-2024-poinner');
  var windowHeight = window.innerHeight;
  var animationTriggered = false;

  function executeAnimation() {
    if (animationTriggered) return; // 如果动画已触发，则直接返回
    animated();
    animationTriggered = true; // 设置动画已触发的标志
  }

  function checkVisibility() {
    var elementTop = targetElement.getBoundingClientRect().top;
    var elementBottom = targetElement.getBoundingClientRect().bottom;

    if (elementTop < windowHeight && elementBottom >= 0) {
      executeAnimation();
    }
  }

  window.addEventListener('scroll', checkVisibility);
  window.addEventListener('resize', () => {
    windowHeight = window.innerHeight;
    
    checkVisibility();
  });
  checkVisibility(); // 初始检查

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fall-banner-video"] && !Shopify.designMode) return;
  try {
    
  const openPopupBtn = document.getElementById('openPopup')
  const closePopupBtn = document.getElementById('closePopup')
  const videoPopup = document.getElementById('videoPopup')
  const videoPlayer = videoPopup.querySelector('.video-popup video')

  if (openPopupBtn) {
    openPopupBtn.addEventListener('click', function () {
      videoPopup.style.display = 'flex'
      videoPlayer.play()
      document.body.style.overflow = 'hidden'
    })
  }


  document.querySelector(".video-popup").addEventListener("click", function(event) {
    if (event.target === this) {
      videoPopup.style.display = 'none'
      videoPlayer.pause()
      document.body.style.overflow = 'auto'
    }
    })

  if (closePopupBtn) {
    closePopupBtn.addEventListener('click', function () {
      videoPopup.style.display = 'none'
      videoPlayer.pause()
      document.body.style.overflow = 'auto'
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fall-countdown"] && !Shopify.designMode) return;
  try {
    
  // 获取所有swiper-slide元素
  var slides = document.querySelectorAll('.fall-countdown .slide')

  // 计算最大高度
  var maxHeight = 0
  slides.forEach(function (slide) {
    maxHeight = Math.max(maxHeight, slide.offsetHeight)
  })

  // 设置所有swiper-slide的高度为最大高度
  slides.forEach(function (slide) {
    slide.style.height = maxHeight + 'px'
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-valentine-day"] && !Shopify.designMode) return;
  try {
    
  const popverElement = document.querySelector('#popover-right-flash-sale')

  if (!popverElement) {
    return
  }
  const popverBtn = document.querySelector('.popover-btn-flash-sale')
  if (!popverBtn) {
    return
  }
  const popver = new Popover(popverElement)
  popverBtn.addEventListener('click', () => {
    popver.hide()
  })



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale"] && !Shopify.designMode) return;
  try {
    
  const popverElement = document.querySelector('#popover-right-flash-sale')

  if (!popverElement) {
    return
  }
  const popverBtn = document.querySelector('.popover-btn-flash-sale')
  if (!popverBtn) {
    return
  }
  const popver = new Popover(popverElement)
  popverBtn.addEventListener('click', () => {
    popver.hide()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["green-plan-nav"] && !Shopify.designMode) return;
  try {
    
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
  }
  document.addEventListener('DOMContentLoaded', function () {
    const tabsBox = document.querySelector('.sticky-tabs-box')
    if (!tabsBox) return
    var tabs = tabsBox.querySelectorAll('.PageNav')
    var stickyToTop = isMobile(640) ? 48 : 68
    var sections = Array.from(tabs).map(function (tab) {
      var href = tab.getAttribute('href')
      if (href && href !== '#') {
        return document.querySelector(href)
      }
    })
    //处理点击事件
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function (event) {
        event.preventDefault()
        if (sections[index]) {
          window.scrollTo({
            top: sections[index].offsetTop - stickyToTop, // 偏移粘头高度
            behavior: 'smooth'
          })
        }
      })
    })
    // 处理滚动事件
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY
      sections.forEach(function (section, index) {
        if (!section) return
        var sectionTop = section.offsetTop - stickyToTop - 30 // 偏移粘头高度
        var sectionHeight = section.offsetHeight
        var tab = tabs[index]
        // 导航跟随滚动start
        const tabWidth = tab.offsetWidth
        const tabLeft = tab.offsetLeft
        const tabRight = tabLeft + tabWidth + 50
        const tabContainerWidth = tabsBox.offsetWidth
        const tabContainerScrollLeft = tabsBox.scrollLeft
        const tabContainerScrollRight = tabContainerScrollLeft + tabContainerWidth
        // 导航跟随滚动end
        if (section.style.display !== 'none') {
          if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
            tab.classList.add('tm-active')
            // 导航跟随滚动start
            if (tabLeft < tabContainerScrollLeft) {
              tabsBox.scrollTo({
                left: tabLeft - 100,
                behavior: 'smooth'
              })
            } else if (tabRight > tabContainerScrollRight) {
              tabsBox.scrollTo({
                left: tabRight - tabContainerWidth,
                behavior: 'smooth'
              })
            }
            // 导航跟随滚动end
          } else {
            tab.classList.remove('tm-active')
          }
        } else {
          tab.classList.remove('tm-active')
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-battery-image-steps"] && !Shopify.designMode) return;
  try {
    
  class SetupStepsManager {
    constructor(sectionElement) {
      this.section = sectionElement
      this.tabButtons = this.section.querySelectorAll('[data-tab-button]')
      this.mediaItems = this.section.querySelectorAll('[data-media-item]')
      this.currentIndex = 0

      this.initializeEvents()
    }

    initializeEvents() {
      this.tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const targetIndex = parseInt(button.dataset.tabButton)
          this.switchToTab(targetIndex)
        })
      })
    }

    switchToTab(targetIndex) {
      if (targetIndex === this.currentIndex) return

      // 更新 tab 按钮状态
      this.updateTabButtons(targetIndex)

      // 切换图片
      this.switchMedia(targetIndex)

      this.currentIndex = targetIndex
    }

    updateTabButtons(targetIndex) {
      this.tabButtons.forEach((button, index) => {
        if (index === targetIndex) {
          button.classList.add('active')
        } else {
          button.classList.remove('active')
        }
      })
    }

    switchMedia(targetIndex) {
      this.mediaItems.forEach((item, index) => {
        if (index === targetIndex) {
          item.classList.remove('hidden')
        } else {
          item.classList.add('hidden')
        }
      })
    }
  }

  // 初始化组件
  const initSetupSteps = () => {
    const setupStepsSections = document.querySelectorAll('.setup-steps[data-section-id]')

    setupStepsSections.forEach((section) => {
      new SetupStepsManager(section)
    })
  }

  // 页面加载时初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSetupSteps)
  } else {
    initSetupSteps()
  }

  // Shopify 主题编辑器支持
  if (Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('setup-steps')) {
        new SetupStepsManager(event.target)
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-battery-story"] && !Shopify.designMode) return;
  try {
    
  class videoComponent extends HTMLElement {
    constructor() {
      super()
      this.isShowMore = false
      this.showString = {
        show: 'See More',
        close: 'Close'
      }
      this.playsBtns = this.querySelectorAll('[data-code]')

      this.init()
    }

    play(code) {
      if (!code) {
        return
      }
      const videoUrl = `//www.youtube-nocookie.com/embed/${code}?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=1`
      const videoElement = `<button class="uk-modal-close-outside" type="button" uk-close></button><iframe src="${videoUrl}" width="1920" height="1080" allowfullscreen uk-responsive uk-video></iframe>`
      UIkit.modal.dialog(
        `<div>${videoElement}<style>.uk-modal{display: flex!important;}.uk-modal-dialog {width: 1200px;margin-top: auto!important;margin-bottom: auto!important;}</style></div>`
      )
    }

    init() {
      const playLength = this.playsBtns.length
      if (playLength >= 1) {
        this.playsBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.target.blur()
            this.play(e.target.dataset.code)
          })
        })
      }
    }
  }
  customElements.define('video-component', videoComponent)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["level-comparison"] && !Shopify.designMode) return;
  try {
    
  var level_list = document.querySelectorAll('.tm-level-click .level-items');
  level_list.forEach(function(item) {
    item.addEventListener('click', function() {
      var type = item.getAttribute('data-type');
      var modal = document.getElementById('level-modal-info');
      modal
        .querySelectorAll(".tm-level-child-item")
        .forEach(function(item) {
          if (item.classList.value.indexOf(type) >= 0) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        })
        document
        .querySelector("body")
        .style
        .overflow = 'hidden';
      modal.classList.add("uk-open");
    }, false)
  })
  var levelModal = document.querySelector("#level-modal-info");
  levelModal.addEventListener('click', (e) => {
    if (e.target === levelModal || e.target.localName == 'button') {
      document.querySelector("body").style.overflow = "auto";
      levelModal.classList.remove("uk-open");
    }
  }, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super()

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value })
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
        }, 300)
      )
    }
  }
  customElements.define('cart-note', CartNote)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-sale-product-list-new"] && !Shopify.designMode) return;
  try {
    
  const tabs = document.querySelectorAll('.awards-tab > div');
  const tabContents = document.querySelectorAll('.awards-tab-content > div');
  const tabContainer = document.querySelector('.awards-tab');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');

      tabContents.forEach((content) => content.classList.add('hidden'));
      tabContents[index].classList.remove('hidden');

      const tabWidth = tab.offsetWidth;
      const tabLeft = tab.offsetLeft;
      const tabRight = tabLeft + tabWidth + 50;
      const tabContainerWidth = tabContainer.offsetWidth;
      const tabContainerScrollLeft = tabContainer.scrollLeft;
      const tabContainerScrollRight = tabContainerScrollLeft + tabContainerWidth;

      if (tabLeft < tabContainerScrollLeft) {
        tabContainer.scrollTo({
          left: tabLeft - 100,
          behavior: 'smooth',
        });
      } else if (tabRight > tabContainerScrollRight) {
        tabContainer.scrollTo({
          left: tabRight - tabContainerWidth,
          behavior: 'smooth',
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newComerNav"] && !Shopify.designMode) return;
  try {
    
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
  }
  document.addEventListener('DOMContentLoaded', function() {
    const tabsBox = document.querySelector('.sticky-tabs-box')
    if (! tabsBox) return

    

    var tabs = tabsBox.querySelectorAll('.PageNav')
    var stickyToTop = isMobile(640)
      ? 80
      : 105
    var sections = Array
      .from(tabs)
      .map(function(tab) {
        var href = tab.getAttribute('href')
        if (href && href !== '#') {
          return document.querySelector(href)
        }
      })

  // 处理点击事件
      tabs
      .forEach((tab, index) => {
        tab.addEventListener('click', function(event) {
          event.preventDefault()
          if (sections[index]) {
            window.scrollTo({
              top: sections[index].offsetTop - stickyToTop, // 偏移粘头高度
              behavior: 'smooth'
            })
          }
        })
      })

  // 处理滚动事件
      window
      .addEventListener('scroll', function() {
        var scrollY = window.scrollY
        sections.forEach(function(section, index) {
          if (! section) return

          

          var sectionTop = section.offsetTop - stickyToTop - 30 // 偏移粘头高度
          var sectionHeight = section.offsetHeight
          var tab = tabs[index]

// 导航跟随滚动start
          const tabWidth = tab.offsetWidth
          const tabLeft = tab.offsetLeft
          const tabRight = tabLeft + tabWidth + 50
          const tabContainerWidth = tabsBox.offsetWidth
          const tabContainerScrollLeft = tabsBox.scrollLeft
          const tabContainerScrollRight = tabContainerScrollLeft + tabContainerWidth

// 导航跟随滚动end
          if (section.style.display !== 'none') {
            if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
              tab.classList.add('tm-active')

// 导航跟随滚动start
              if (tabLeft < tabContainerScrollLeft) {
                tabsBox.scrollTo({
                  left: tabLeft - 100,
                  behavior: 'smooth'
                })
              } else if (tabRight > tabContainerScrollRight) {
                tabsBox.scrollTo({
                  left: tabRight - tabContainerWidth,
                  behavior: 'smooth'
                })
              }

// 导航跟随滚动end
            } else {
              tab.classList.remove('tm-active')
            }
          } else {
            tab.classList.remove('tm-active')
          }
        })
      })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ppsStory"] && !Shopify.designMode) return;
  try {
    
  class videoComponent1 extends HTMLElement {
    constructor() {
      super()
      this.isShowMore = false
      this.showString = {
        show: 'See More',
        close: 'Close'
      }
      this.playsBtns = this.querySelectorAll('[data-code]')

      this.init()
    }

    play(code) {
      if (!code) {
        return
      }
      const videoUrl = `//www.youtube-nocookie.com/embed/${code}?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=1`
      const videoElement = `<button class="uk-modal-close-outside" type="button" uk-close></button><iframe src="${videoUrl}" width="1920" height="1080" allowfullscreen uk-responsive uk-video></iframe>`
      UIkit.modal.dialog(
        `<div>${videoElement}<style>.uk-modal{display: flex!important;}.uk-modal-dialog {width: 1200px;margin-top: auto!important;margin-bottom: auto!important;}</style></div>`
      )
    }

    init() {
      const playLength = this.playsBtns.length
      if (playLength >= 1) {
        this.playsBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.target.blur()
            this.play(e.target.dataset.code)
          })
        })
      }
    }
  }
  customElements.define('video-component1', videoComponent1)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tech-specs"] && !Shopify.designMode) return;
  try {
    
  const nullState = `<div class="uk-container uk-position-relative uk-section-small uk-padding-remove-top"><span class="uk-h4">Null</span></div>`
  class tabs {
    constructor(container) {
      this.state = {
        cacheData: {}
      }
      this.selectors = {
        tabButtons: container.querySelectorAll('[data-tech-handle]'),
        tabContent: container.querySelector('[data-tech-content]')
      }
      if (this.selectors.tabButtons.length) {
        this.init()
      }
    }
    init() {
      const { state, selectors } = this
      const { cacheData } = state
      const { tabButtons, tabContent } = selectors
      const key = `TAB0`
      const fistTabHandle = tabButtons[0].dataset.techHandle
      if (location.href.indexOf(fistTabHandle) !== -1) {
        cacheData[key] = tabContent.innerHTML
      } else {
        this.updateSections(0, tabButtons[0].dataset.techHandle)
      }

      tabButtons.forEach((element, index) => {
        element.addEventListener(
          'click',
          (event) => {
            event.target
              .closest('ul')
              .querySelectorAll('li')
              .forEach((e) => e.classList.remove('tm-active'))
            event.target.closest('li').classList.add('tm-active')
            this.updateSections(index, event.target.dataset.techHandle)
          },
          false
        )
      })
    }
    async updateSections(index, url) {
      const key = `TAB${index}`
      const { state, selectors } = this
      const { cacheData } = state
      const { tabContent } = selectors
      if (!cacheData[key]) {
        const data = await this.requestData(url)
        tabContent.innerHTML = cacheData[key] = data ? data : nullState
      } else {
        tabContent.innerHTML = cacheData[key]
      }
    }
    async requestData(url) {
      return await fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          console.log('=======111=======')
          console.log(html)
          return html.querySelector('[data-tech-content]').innerHTML
        })
    }
  }
  new tabs(document.querySelector('[data-section-type="product-tech-specs"]'))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["public-collection"] && !Shopify.designMode) return;
  try {
    
const itemBtn = document.querySelectorAll('[data-grid-item]');
let nowProductUrl = '';
if (itemBtn.length > 0) {
  itemBtn.forEach(element => {
    element.addEventListener('click', async event => {
      event.preventDefault();
      const { target } = event;
      const url = `${target.href}`;
      UIkit.modal('#js-product-modal').show();
      if (url === nowProductUrl) return;

      document.querySelector('[data-quick-container]').innerHTML = `<div class="uk-position-cover uk-flex uk-flex-center uk-flex-middle"><i uk-spinner="ratio: 1.3;"></i></div>`;
      nowProductUrl = url;
      const source = await fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          return html.querySelector('[data-main-product]')
        });

      if (source) {
        document.querySelector('[data-quick-container]').innerHTML = source.innerHTML;
        Shopify.PaymentButton.init();
        try {
          affirm.ui.refresh()
        } catch (e) {
          console.error(e)
        }
      }
    })
  })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sctionNavV1"] && !Shopify.designMode) return;
  try {
    
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
  }

  document.addEventListener('DOMContentLoaded', function () {
    const tabsBox = document.querySelector('.sticky-tabs-box')
    if (!tabsBox) return
    var isSmoothScroll = tabsBox.getAttribute('data-smooth-scroll') === 'true' // 是否平滑滚动
    if (!isSmoothScroll) {
      document.documentElement.style.scrollBehavior = 'auto'
    }

    var tabs = tabsBox.querySelectorAll('.PageNav')
    var stickyToTop = isMobile(640) ? 48 : 72 // 粘头高度
    var sections = Array.from(tabs).map(function (tab) {
      var href = tab.getAttribute('href')
      if (href && href !== '#') {
        return document.querySelector(href)
      }
    })
    //处理点击事件
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function (event) {
        event.preventDefault()
        setTimeout(() => {
          if (sections[index]) {
            if (isSmoothScroll) {
              window.scrollTo({
                top: sections[index].getBoundingClientRect().top + window.scrollY - stickyToTop,
                behavior: 'smooth'
              })
            } else {
              window.scrollTo(0, sections[index].getBoundingClientRect().top + window.scrollY - stickyToTop) // 禁止平滑滚动，直接跳转到目标
            }
          }
        }, 0)
      })
    })
    // 处理滚动事件
    let ticking = false
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var scrollY = window.scrollY
          sections.forEach(function (section, index) {
            if (!section) return
            var sectionTop = section.getBoundingClientRect().top + window.scrollY - stickyToTop - 30 // 偏移粘头高度
            var sectionHeight = section.offsetHeight
            var tab = tabs[index]

            // 导航跟随滚动start
            const tabWidth = tab.offsetWidth
            const tabLeft = tab.offsetLeft
            const tabRight = tabLeft + tabWidth + 50
            const tabContainerWidth = tabsBox.offsetWidth
            const tabContainerScrollLeft = tabsBox.scrollLeft
            const tabContainerScrollRight = tabContainerScrollLeft + tabContainerWidth
            // 导航跟随滚动end
            if (section.style.display !== 'none') {
              if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
                tab.classList.add('tm-active')
                // 导航跟随滚动start
                if (tabLeft < tabContainerScrollLeft) {
                  tabsBox.scrollTo({
                    left: tabLeft - 100,
                    behavior: 'smooth'
                  })
                } else if (tabRight > tabContainerScrollRight) {
                  tabsBox.scrollTo({
                    left: tabRight - tabContainerWidth,
                    behavior: 'smooth'
                  })
                }
                // 导航跟随滚动end
              } else {
                tab.classList.remove('tm-active')
              }
            } else {
              tab.classList.remove('tm-active')
            }
            ticking = false
          })
        })
        ticking = true
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-new-2024"] && !Shopify.designMode) return;
  try {
    
  class Slideshow {
    constructor(container) {
      this.container = container;
      this.firstType = this.container.querySelector('[uk-slideshow].js-enable-top')
        ? this.container.querySelector('[uk-slideshow].js-enable-top li').classList.contains('uk-light')
        : false;
      this.initSlideshow(this.firstType);
      this.init();
    }

    initSlideshow(flag) {
      document.querySelector('.tm-header').classList.toggle('uk-light', flag);
    }

    init() {
      this.container.querySelector('[uk-slideshow].js-enable-top')?.addEventListener('beforeitemshow', (e) => {
        const is_light = e.target.classList.contains('uk-light');
        this.initSlideshow(is_light);
      });
    }
  }
  if (document.querySelector('[data-section-type="slideshow"]')) {
    new Slideshow(document.querySelector('[data-section-type="slideshow"]'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class Slideshow {
    constructor(container) {
      this.container = container;
      this.firstType = this.container.querySelector('[uk-slideshow].js-enable-top li').classList.contains('uk-light');
      this.initSlideshow(this.firstType);
      this.init();
    }

    initSlideshow(flag) {
      document.querySelector('.tm-header').classList.toggle('uk-light', flag);
    }

    init() {
      this.container.querySelector('[uk-slideshow].js-enable-top')?.addEventListener('beforeitemshow', (e) => {
        const is_light = e.target.classList.contains('uk-light');
        this.initSlideshow(is_light);
      });
    }
  }
  new Slideshow(document.querySelector('[data-section-type="slideshow"]'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar-battery-story-v2"] && !Shopify.designMode) return;
  try {
    
  class videoPlayComponent extends HTMLElement {
    constructor() {
      super()
      this.isShowMore = false
      this.showString = {
        show: 'See More',
        close: 'Close'
      }
      this.playsBtns = this.querySelectorAll('[data-code]')

      this.init()
    }

    play(code) {
      if (!code) {
        return
      }
      const videoUrl = `//www.youtube-nocookie.com/embed/${code}?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=1`
      const videoElement = `<button class="uk-modal-close-outside" type="button" uk-close></button><iframe src="${videoUrl}" width="1920" height="1080" allowfullscreen uk-responsive uk-video></iframe>`
      UIkit.modal.dialog(
        `<div>${videoElement}<style>.uk-modal{display: flex!important;}.uk-modal-dialog {width: 1200px;margin-top: auto!important;margin-bottom: auto!important;}</style></div>`
      )
    }

    init() {
      const playLength = this.playsBtns.length
      if (playLength >= 1) {
        this.playsBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.target.blur()
            this.play(e.target.dataset.code)
          })
        })
      }
    }
  }
  customElements.define('video-play-component', videoPlayComponent)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar-generator-v2-nav"] && !Shopify.designMode) return;
  try {
    
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
  }
  document.addEventListener('DOMContentLoaded', function () {
    const tabsBox = document.querySelector('.sticky-tabs-box')
    if (!tabsBox) return
    var tabs = tabsBox.querySelectorAll('.PageNav')
    var stickyToTop = isMobile(640) ? 48 : 68
    var sections = Array.from(tabs).map(function (tab) {
      var href = tab.getAttribute('href')
      if (href && href !== '#') {
        return document.querySelector(href)
      }
    })
    //处理点击事件
    tabs.forEach((tab,index) => {
      tab.addEventListener('click', function (event) {
        event.preventDefault()
        if (sections[index]) {
          window.scrollTo({
            top: sections[index].offsetTop - stickyToTop, // 偏移粘头高度
            behavior: 'smooth'
          })
        }
      })
    })
    // 处理滚动事件
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY
      sections.forEach(function (section, index) {
        if (!section) return
        var sectionTop = section.offsetTop - stickyToTop - 30 // 偏移粘头高度
        var sectionHeight = section.offsetHeight
        var tab = tabs[index]
        // 导航跟随滚动start
        const tabWidth = tab.offsetWidth
        const tabLeft = tab.offsetLeft
        const tabRight = tabLeft + tabWidth + 50
        const tabContainerWidth = tabsBox.offsetWidth
        const tabContainerScrollLeft = tabsBox.scrollLeft
        const tabContainerScrollRight = tabContainerScrollLeft + tabContainerWidth
        // 导航跟随滚动end
        if (section.style.display !== 'none') {
          if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
            tab.classList.add('tm-active')
            // 导航跟随滚动start
            if (tabLeft < tabContainerScrollLeft) {
              tabsBox.scrollTo({
                left: tabLeft - 100,
                behavior: 'smooth'
              })
            } else if (tabRight > tabContainerScrollRight) {
              tabsBox.scrollTo({
                left: tabRight - tabContainerWidth,
                behavior: 'smooth'
              })
            }
            // 导航跟随滚动end
          } else {
            tab.classList.remove('tm-active')
          }
        } else {
          tab.classList.remove('tm-active')
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar-image-text-2"] && !Shopify.designMode) return;
  try {
    
  /** 
   * 获取section-{{ section.id }}中的solar-image-text-2-tabs的所有solar-image-text-2-tab元素
   * 给每个solar-image-text-2-tab元素添加点击事件，点击时，给当前元素添加active类名，移除其他元素的active类名，5秒后切换到下一个元素。
   * 进入视口时，给第一个solar-image-text-2-tab元素添加active类名并开始播放
   * 离开视口时，停止播放
   */
  document.addEventListener('DOMContentLoaded', function () {
    const tabsContainer = document.querySelector('.solar-image-text-2-tabs');
    const tabs = tabsContainer.querySelectorAll('.solar-image-text-2-tab');
    
    let activeIndex = 0;
    let interval;

    function setActiveTab(index) {
      tabs.forEach((tab, i) => {
        if (i === index) {
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });
    }

    function startAutoPlay() {
      interval = setInterval(() => {
        activeIndex = (activeIndex + 1) % tabs.length;
        setActiveTab(activeIndex);
      }, 5000);
    }

    function stopAutoPlay() {
      clearInterval(interval);
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        stopAutoPlay();
        activeIndex = index;
        setActiveTab(activeIndex);
        startAutoPlay();
      });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveTab(activeIndex);
            startAutoPlay();
          } else {
            stopAutoPlay();
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(tabsContainer);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["speed-dial"]) return;
  try {
    
  class SpeedDial extends HTMLElement {
    constructor() {
      super()

      // 元素的初始化逻辑
      this.speedDial = null
      this.mainButton = null
      this.subButtons = null
    }

    connectedCallback() {
      // 在元素插入到文档中的时候, 初始化引用并绑定事件
      this.speedDial = this
      this.mainButton = this.speedDial.querySelector('.main-button')
      this.subButtons = this.speedDial.querySelectorAll('.sub-button')
      this.mainButton.addEventListener('click', this.toggleSubButtons.bind(this))
    }

    disconnectedCallback() {
      // 在元素从文档中移除时解绑事件
      if (this.mainButton) {
        this.mainButton.removeEventListener('click', this.toggleSubButtons.bind(this))
      }
      this.removeGlobalClickListener()
    }

    toggleSubButtons(event) {
      if (this.speedDial) {
        this.speedDial.classList.toggle('show')
        if (this.speedDial.classList.contains('show')) {
          this.addGlobalClickListener()
          this.calculateSubButtonPositions()
        } else {
          this.resetSubButtonPositions()
          this.removeGlobalClickListener()
        }
      }
      event.stopPropagation() // 防止事件冒泡到document
    }

    calculateSubButtonPositions() {
      const distance = this.getDistance()
      this.subButtons.forEach((button, index) => {
        const y = -(distance * (index + 1)) // Calculate the upward position
        // Set the position of the sub-buttons
        button.style.transform = `translateY(${y}px)`
      })
    }

    resetSubButtonPositions() {
      this.subButtons.forEach((button) => {
        // Reset the position back to initial
        button.style.transform = 'translateY(0)'
      })
    }

    addGlobalClickListener() {
      document.addEventListener('click', this.handleClickOutside.bind(this))
    }

    removeGlobalClickListener() {
      document.removeEventListener('click', this.handleClickOutside.bind(this))
    }

    handleClickOutside(event) {
      if (this.speedDial && !this.speedDial.contains(event.target)) {
        this.resetSubButtonPositions() // Important: Reset positions before hiding
        this.speedDial.classList.remove('show')
        this.removeGlobalClickListener()
      }
    }

    getDistance() {
      return window.matchMedia('(max-width: 768px)').matches ? 50 : 60
    }
  }

  customElements.define('speed-dial', SpeedDial)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-faqs"] && !Shopify.designMode) return;
  try {
    
let flag = false;
const showString = {
show: "Show More",
close: "Close"
}
document.querySelectorAll('[data-group]').forEach(element => {
const oBtn = element.querySelector('button');
if (oBtn) {
oBtn.addEventListener('click', (e) => {
flag = !flag;
e.target.innerHTML = flag ? showString.close : showString.show;
element.querySelector('[uk-accordion]').classList.toggle('open', flag)
});
}
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technology-v3-bluelink"] && !Shopify.designMode) return;
  try {
    
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
  }
  document.addEventListener('DOMContentLoaded', () => {
    const pcBg = document.getElementById('pc-bg')

    if (isMobile(768)) {
      // pc 端
      pcBg.style.background = 'none'
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technology-v3-bluepeak"] && !Shopify.designMode) return;
  try {
    
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log('文字元素进入视口:')
          const video = document.getElementById('bg-video')
          video.style.filter = `brightness(${0.4})`
        }
      })
    },
    {
      threshold: 0 //  可见时触发
    }
  )
  const observer2 = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          const video = document.getElementById('bg-video')
          // 元素离开视口
          video.style.filter = `brightness(${1})`
          console.log('文字元素离开视口:')
        }
      })
    },
    {
      threshold: 0 //  可见时触发
    }
  )
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!isMobile(768)) {
      // pc 端才会有动画
      const firstText = document.getElementById('first-text')
      observer.observe(firstText)
      const lastText = document.getElementById('last-text')
      observer2.observe(lastText)
    }
    const track = document.querySelector('.carousel__track')
    const slides = Array.from(track.children)
    const prevBtn = document.querySelector('.carousel__btn--prev')
    const nextBtn = document.querySelector('.carousel__btn--next')
    const dotsContainer = document.querySelector('.dots')
    const slideCount = slides.length
    let index = 0 // 初始位置：指向「第一个真实 slide」在克隆队列中的索引
    // 生成分页圆点
    for (let i = 0; i < slideCount; i++) {
      const dot = document.createElement('span')
      dot.classList.add('dot')
      dot.dataset.index = i
      dotsContainer.appendChild(dot)
      dot.addEventListener('click', () => goToSlide(i))
    }

    const dots = document.querySelectorAll('.dot')
    dots[0].classList.add('active')

    // 1. 克隆首尾 slide
    const firstClone = slides[0].cloneNode(true)
    const lastClone = slides[slideCount - 1].cloneNode(true)
    track.appendChild(firstClone)
    track.insertBefore(lastClone, track.firstChild)
    // Array.from(track.children)[2].classList.add('slide-active')
    // 2. 设置初始偏移到「真实第 1 张」
    const slideWidth = slides[0].getBoundingClientRect().width
    // 24是间距
    track.style.transform = `translateX(-${slideWidth * index + 24}px)`
    function update(index) {
      dots.forEach((d) => d.classList.remove('active'))
      dots[index % slideCount].classList.add('active')
    }
    // 切换函数
    function moveTo(newIndex) {
      index = newIndex
      track.style.transition = 'transform 0.1s ease'
      track.style.transform = `translateX(-${(slideWidth + 24) * index}px)`
      update(index)
    }
    function goToSlide(index) {
      index = index
      update(index)
      moveTo(index)
    }
    // 边界检测：在动画结束后，如果走到了克隆节点，就瞬移到真实节点
    track.addEventListener('transitionend', () => {
      // 最前面的是 lastClone
      if (index === 0) {
        track.style.transition = 'none'
        index = slideCount
        track.style.transform = `translateX(-${(slideWidth + 24) * index}px)`
      }
      // 最后面的是 firstClone
      if (index === slideCount + 1) {
        track.style.transition = 'none'
        index = 1
        track.style.transform = `translateX(-${(slideWidth + 24) * index}px)`
      }
    })

    // 按钮绑定
    prevBtn.addEventListener('click', () => moveTo(index - 1))
    nextBtn.addEventListener('click', () => moveTo(index + 1))
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technology-v3-tab"] && !Shopify.designMode) return;
  try {
    
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
  }
  document.addEventListener('DOMContentLoaded', function () {
    const tabsBox = document.querySelector('.sticky-tabs-box')
    if (!tabsBox) return
    var tabs = tabsBox.querySelectorAll('.PageNav')
    var stickyToTop = isMobile(640) ? 48 : 68
    var sections = Array.from(tabs).map(function (tab) {
      var href = tab.getAttribute('href')
      if (href && href !== '#') {
        return document.querySelector(href)
      }
    })
    //处理点击事件
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function (event) {
        event.preventDefault()
        if (sections[index]) {
          window.scrollTo({
            top: sections[index].offsetTop - stickyToTop, // 偏移粘头高度
            behavior: 'smooth'
          })
        }
      })
    })
    // 处理滚动事件
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY
      sections.forEach(function (section, index) {
        if (!section) return
        var sectionTop = section.offsetTop - stickyToTop - 30 // 偏移粘头高度
        var sectionHeight = section.offsetHeight
        var tab = tabs[index]

        // 导航跟随滚动start
        const tabWidth = tab.offsetWidth
        const tabLeft = tab.offsetLeft
        const tabRight = tabLeft + tabWidth + 50
        const tabContainerWidth = tabsBox.offsetWidth
        const tabContainerScrollLeft = tabsBox.scrollLeft
        const tabContainerScrollRight = tabContainerScrollLeft + tabContainerWidth
        // 导航跟随滚动end
        if (section.style.display !== 'none') {
          if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
            tab.classList.add('tm-active')
            // 导航跟随滚动start
            if (tabLeft < tabContainerScrollLeft) {
              tabsBox.scrollTo({
                left: tabLeft - 100,
                behavior: 'smooth'
              })
            } else if (tabRight > tabContainerScrollRight) {
              tabsBox.scrollTo({
                left: tabRight - tabContainerWidth,
                behavior: 'smooth'
              })
            }
            // 导航跟随滚动end
          } else {
            tab.classList.remove('tm-active')
          }
        } else {
          tab.classList.remove('tm-active')
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technology-v3-topVideoText"] && !Shopify.designMode) return;
  try {
    
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log('文字元素进入视口:')
          entry.target.classList.add('opacity-100')
          entry.target.classList.remove('opacity-0')
        } else {
          console.log('文字元素离开视口123:')
          entry.target.classList.remove('opacity-100')
          entry.target.classList.add('opacity-0')
        }
      })
    },
    {
      root: null,
      threshold: 0.1 //  可见时触发
    }
  )
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!isMobile(768)) {
      const pc = document.getElementById('bottom-text')
      observer.observe(pc)
    } else {
      const mb = document.getElementById('mobile-bottom-text')
      observer.observe(mb)
    }
  })

  } catch(e) { console.error(e); }
})();
})();
